import { createSelector } from 'reselect';
import { selectSignInSliderDetails } from './fromState';

export const getSignInSliderDetails = createSelector(
    [selectSignInSliderDetails],
    (signInSliderDetails) => signInSliderDetails
);

export default {
    getSignInSliderDetails,
};
